module.exports = __webpack_public_path__ + "static/media/folderIconSelf.33d49102.svg";